import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination, Autoplay, FreeMode } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="logos"]');

class Logos {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const swiperComponent = component.querySelector('.swiper');
            if (swiperComponent) this.initSwiper(swiperComponent);
        });
    }

    initSwiper(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Pagination, Navigation, Autoplay, FreeMode],
            slidesPerView: 5,
            slidesPerGroup: 5,
            autoplay: {
                delay: 8000
            },
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperComponent.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
        });
    }
}

(() => {
    if (MODULE) {
        new Logos();
    }
})();

export default Logos;
